<template>
    <div class="col-12">
        <div class="row">
            <b-overlay :show="loading" class="content">
                <div class="mb-3 text-center">
                    <hr />
                    <strong>{{ $t("view.club.menus.cards") }}</strong>
                    <hr />
                </div>
                <table v-if="screenWidth > 1021"
                       class="table table-bordered bg-white table-striped text-center">
                    <thead>
                        <tr>
                            <th>{{ $t("param.record") }}</th>
                            <th v-for="field in fields" v-if="field.showCell" :key="field.key">
                                {{ $t("param." + field.key) }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in items" @click="onShowDatails(item)">
                            <td>
                                {{ index + (currentPage - 1) * perPage + 1 }}
                            </td>
                            <td v-for="field in fields" v-if="field.showCell">
                                {{
                field.money
                  ? new Intl.NumberFormat().format(item[field.key])
                  : item[field.key]
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table v-if="screenWidth < 1024"
                       v-for="(item, index) in items"
                       class="table table-light table-silver table-pill mb-2 text-right">
                    <tr v-for="field in fields" v-if="field.showCell">
                        <th>
                            {{ $t("param." + field.key) }}
                        </th>
                        <td>
                            <span v-if="field.key == 'record'">
                                {{ index + (currentPage - 1) * perPage + 1 }}
                            </span>
                            <span v-else v-bind:class="{ 'card-number': field.cardNumber }">
                                {{
                field.money
                  ? new Intl.NumberFormat().format(item[field.key])
                  : item[field.key]
                                }}
                            </span>
                        </td>
                    </tr>
                </table>

                <b-pagination dir="ltr"
                              pills
                              @input="initTable"
                              v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                              size="sm"></b-pagination>
            </b-overlay>
        </div>
    </div>
</template>
<script>
    export default {
        data()
        {
            return {
                screenWidth: null,
                loading: false,
                items: [],
                fields: [
                    {
                        key: "customerCardID",
                        showCell: false,
                        shotDetails: false
                    },
                    {
                        key: "customerCardTypeName",
                        showCell: true,
                        shotDetails: true
                    },
                    {
                        key: "cardNumber",
                        showCell: true,
                        shotDetails: true
                    },
                    {
                        key: "cvv2",
                        showCell: true,
                        shotDetails: true
                    },
                    {
                        key: "exYear",
                        showCell: true,
                        shotDetails: true
                    },
                    {
                        key: "exMonth",
                        showCell: true,
                        shotDetails: true
                    }
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 10
            };
        },

        beforeMount()
        {
            this.screenWidth = window.outerWidth;
            this.initTable();
        },

        mounted()
        {
            this.totalRows = this.items.length;
        },

        methods: {
            initTable()
            {
                this.loading = true;

                const data = {
                    Search: "",
                    Start: (this.currentPage - 1) * this.perPage,
                    Length: 10
                };

                axios({ method: "post", url: "/api/App/GetCustomerCards", data: data })
                    .then(response =>
                    {
                        this.items = response.data.meta.transactions;
                        this.totalRows = response.data.meta.totalRows;
                        this.loading = false;
                    })
                    .catch(error => { });
            }
        }
    };
</script>
